import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import DisplayBox from "components/DisplayBox";

/**
 * ApplicationDisplayBoxSection
 *
 * @params {element}      title
 * @params {String}       data
 * @params {String}       msgId
 * @params {elementType}  renderer - React component to render
 * @params {object}       rendererProps - Props to pass to the renderer component
 */
const ApplicationDisplayBoxSection = ({ title, data, msgId, renderer: BodyComponent, rendererProps, ...props }) => (
  <DisplayBox
    title={title || <FormattedMessage id={msgId} />}
    numColumns={1}
    data={BUILD_DATA(BodyComponent ? <BodyComponent {...rendererProps} /> : data)}
    {...props}
  />
);

const BUILD_DATA = (data) => [
  {
    title: null,
    body: data,
  },
];

ApplicationDisplayBoxSection.propTypes = {
  title: PropTypes.element,
  data: PropTypes.string.isRequired,
  msgId: PropTypes.string,
  renderer: PropTypes.elementType,
  rendererProps: PropTypes.object,
};

export default ApplicationDisplayBoxSection;
